import React from 'react';

import Box from '@material-ui/core/Box';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import CardMenu from './getStarted/menu/CardMenu'

import Copyright from './furniture/Copyright'
import AppBarAndDrawer from './furniture/AppBarAndDrawer'
import {useStyles}from './furniture/Dashboard-Config'

import { useOvermind } from '../overmind';
import NewSessionLoader from './accountSelection/NewSessionLoader'

export default function Overview(){
  const classes = useStyles();
  const { state, actions } = useOvermind();

  if(state.blockAccess){
    actions.updateFlag({'name':'redirectPath','payload':'/get-started'});
    return(<NewSessionLoader/>);
  }else{
    return (
      <div className={classes.root}>
        <AppBarAndDrawer/>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>

            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
              <Paper className={classes.paper}>
                <Typography variant="h6" color="primary" gutterBottom >
                  Welcome to GTM Docs!
                </Typography>
                <Typography variant="body1"  gutterBottom >
                  GTM Docs is a tool for Google Tag Manager administators. It makes management and maintaince faster and easier by providing quick insight through visualization, a rule based audit, and automated documentation.  This allows you to manage any Google Tag Manager instance with ease.
                </Typography>
              </Paper>
              </Grid>
            </Grid>

            {/* Card Menu Options  <CardMenu />*/}


            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>
    );
  }
}
